module.exports = __webpack_public_path__ + "static/card-collection-cf246087dc07bf58100edaddcbad3806.svg";